<template>
  <div class="scroller" :class="props.colorMode ? `scroller--${props.colorMode}` : ''">
    <div class="scroller__gradient scroller__gradient--left" v-if="canScrollLeft"></div>
    <div
      class="scroller__arrow scroller__arrow--left"
      v-show="canScrollLeft"
      @mouseenter="startScroll('left')"
      @mouseleave="stopScroll"
      @click="makeBigShift('left')"
    >
      <ArrowTiny class="scroller__arrow-icon" />
    </div>
    <div class="scroller__container" ref="container" @scroll="updateScrollState">
      <slot />
    </div>
    <div
      class="scroller__arrow scroller__arrow--right"
      v-show="canScrollRight"
      @mouseenter="startScroll('right')"
      @mouseleave="stopScroll"
      @click="makeBigShift('right')"
    >
      <ArrowTiny class="scroller__arrow-icon" />
    </div>
    <div class="scroller__gradient scroller__gradient--right" v-if="canScrollRight"></div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  import { ref, onMounted, onBeforeUnmount } from 'vue';

  //---------------------------------------------
  import ArrowTiny from '@svg/ArrowTiny.vue';

  //---------------------------------------------
  const props = defineProps(Props());

  //---------------------------------------------
  const container = ref(null);
  const scrollInterval = ref(null);
  const canScrollLeft = ref(false);
  const canScrollRight = ref(false);

  //---------------------------------------------
  const SCROLL_STEP = 70;
  const BIG_SCROLL_STEP = 100;

  //---------------------------------------------
  onMounted(async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    startScroll('left');
    window.addEventListener('resize', updateScrollState);
  });
  
  onBeforeUnmount(() => {
    stopScroll();
    window.removeEventListener('resize', updateScrollState);
  });

  //---------------------------------------------
  //Обновляет флаги скролла: можно ли прокручивать влево или вправо
  const updateScrollState = () => {
    const el = container.value;
    if (!el) return;
    canScrollLeft.value = el.scrollLeft > 0;
    canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  };

  //Запускает автоматическую прокрутку в указанную сторону при наведении
  const startScroll = (direction) => {
    stopScroll();
    useScroll(direction, SCROLL_STEP);
    updateScrollState();
    scrollInterval.value = setInterval(() => {
      useScroll(direction, SCROLL_STEP);
      updateScrollState();
    }, 300);
  };

  //Сделать большой сдвиг
  const makeBigShift = (direction) => {
    useScroll(direction, BIG_SCROLL_STEP);
  }

  //Использовать скролл
  const useScroll = (direction, step) => {
    container.value?.scrollBy({ left: direction === 'left' ? -step : step, behavior: 'smooth' });
  }

  //Останавливает автоматическую прокрутку
  const stopScroll = () => {
    if(!scrollInterval.value) return;
    clearInterval(scrollInterval.value);
    scrollInterval.value = null;
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>